import React, { Fragment } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

import styles from './styles.scss';

function PlanLayout({ t, name, children }) {
  return (
    <Fragment>
      <h2 className={styles.title}>
        {t('modals.plan.title')}
      </h2>
      <h3 className={styles.name}>
        {name}
      </h3>
      <p className={styles.body}>
        {t('modals.plan.has')}
      </p>
      <ul className={styles.body}>
        {children}
      </ul>
    </Fragment>
  );
}

PlanLayout.propTypes = {
  t: PropTypes.func.isRequired,
  name: PropTypes.node,
  children: PropTypes.node,
};

PlanLayout.defaultProps = {
  name: null,
  children: null,
};

export default translate()(PlanLayout);



// WEBPACK FOOTER //
// ./src/app/components/PlanModal/components/PlanLayout/index.js